module.exports = __WEBPACK_EXTERNAL_MODULE_3__;


/*****************
 ** WEBPACK FOOTER
 ** external "React"
 ** module id = 3
 ** module chunks = 0
 **/